<template>
  <v-container class="lead-form-container">
    <h1 class="form-title">Enquire Now</h1>
    <v-form ref="leadForm">
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="lead.name"
            label="Full Name"
            required
            :rules="nameRules"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="lead.email"
            label="Email Address"
            required
            :rules="emailRules"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="lead.phone"
            label="Phone Number"
            required
            :rules="phoneRules"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="lead.message"
            label="Message"
            required
            :rules="messageRules"
            outlined
            dense
            rows="3"
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-btn
            color="primary"
            @click="submitForm"
            :disabled="!isFormValid || loading"
            class="submit-button"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              size="20"
              color="white"
            ></v-progress-circular>
            <span v-else>Submit</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <!-- Confirmation/Error Message -->
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" timeout="4000">
      {{ snackbar.message }}
      <v-btn color="white" text @click="snackbar.visible = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
/* global gtag */

export default {
  name: 'LeadForm',
  data() {
    return {
      lead: {
        name: '',
        email: '',
        phone: '',
        message: '',
        bedrooms: [],
      },
      loading: false,
      snackbar: {
        visible: false,
        message: '',
        color: 'green',
      },
      nameRules: [(v) => !!v || 'Name is required'],
      emailRules: [
        (v) => !!v || 'Email is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      phoneRules: [
        (v) => !!v || 'Phone number is required',
        (v) => /^[89]\d{7}$/.test(v) || 'Phone number must be 8 digits starting with 8 or 9',
      ]
    };
  },
  computed: {
    isFormValid() {
      return (
        this.nameRules.every((rule) => rule(this.lead.name) === true) &&
        this.emailRules.every((rule) => rule(this.lead.email) === true) &&
        this.phoneRules.every((rule) => rule(this.lead.phone) === true)
      );
    },
  },
  methods: {
    async submitForm() {
      if (!this.isFormValid) return;
      this.loading = true;

      const payload = {
        project_id: 'arina-east',
        time: new Date(),
        name: this.lead.name.trim(),
        email: this.lead.email.toLowerCase().trim(),
        phone: this.lead.phone.trim(),
        message: this.lead.message.trim(),
        query_type: this.lead.bedrooms
      };

      try {
        const response = await fetch('https://asia-southeast1-stones-9cc17.cloudfunctions.net/saveContact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          // Send Google Tag event
          gtag('event', 'conversion', {
              'send_to': 'AW-16841310084/3GyCCIK_v6QaEIT_x94-',
              'value': 1.0,
              'currency': 'SGD'
          });

          this.snackbar.message = 'Your enquiry has been submitted successfully!';
          this.snackbar.color = 'green';
          this.resetForm();
        } else {
          this.snackbar.message = 'Error submitting your enquiry. Please try again.';
          this.snackbar.color = 'red';
        }
      } catch (error) {
        console.error('API Error:', error);
        this.snackbar.message = 'Network error. Please check your connection.';
        this.snackbar.color = 'red';
      } finally {
        this.snackbar.visible = true;
        this.loading = false;
      }
    },
    resetForm() {
      this.lead.name = '';
      this.lead.email = '';
      this.lead.phone = '';
      this.lead.message = '';
      this.lead.bedrooms = [];
      
      if (this.$refs.leadForm) {
        this.$refs.leadForm.reset();
      }
    },
  },
};
</script>


<style scoped>
.lead-form-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #F7F4ED;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-title {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50;
  margin: 24px;
  text-align: center;
}

.v-text-field,
.v-textarea {
  margin-bottom: 16px;
}

.submit-button {
  font-size: 1rem;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
}

.submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.v-snackbar {
  bottom: 50px;
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .lead-form-container {
    padding: 10px;
  }

  .form-title {
    font-size: 1.75rem;
  }

  .submit-button {
    font-size: 0.9rem;
    padding: 10px 20px;
  }
}
</style>
